import type {
  ChannelExpandedCommon,
  ChannelProgramResource,
} from '../../../../../api/channel';
import type {StrategyByType} from './types';

export class ChannelProgramStrategy implements StrategyByType {
  getAvatar(channel: ChannelExpandedCommon) {
    const program = (channel.resource as ChannelProgramResource) || null;

    return program?.avatar || null;
  }

  getClientName(_channel: ChannelExpandedCommon) {
    return null;
  }

  getClientSource(_channel: ChannelExpandedCommon) {
    return null;
  }

  getDescription(_channel: ChannelExpandedCommon) {
    return '';
  }

  getIsArchived(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsCorporate(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsEnded(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsIndividual(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsNewClient(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsOneToOne(channel: ChannelExpandedCommon) {
    return channel.user_ids.length === 2;
  }

  getIsStarted(_channel: ChannelExpandedCommon) {
    return false;
  }

  getTitle(channel: ChannelExpandedCommon) {
    const program = (channel.resource as ChannelProgramResource) || null;

    return program?.title || 'Program not found';
  }

  getUserIsFrozen(_channel: ChannelExpandedCommon, _isUserCoach: boolean) {
    return false;
  }
}
